<template>
  <div class="logged-in-user">
    <v-row
      class="logged-in-user--name"
      no-gutters
    >
      <v-col>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
            >
              {{ loginAdmin.name }}
            </div>
          </template>
          <v-list>
            <v-list-item class="py-2">
              <v-row no-gutters>
                <v-col
                  cols="12"
                  class="logged-in-user--name"
                >
                  {{ loginAdmin.name }}
                </v-col>
                <v-col
                  cols="12"
                  class="logged-in-user--info"
                >
                  {{ loginAdmin.email }}
                </v-col>
              </v-row>
            </v-list-item>
            <v-divider />
            <v-list-item>
              <change-password />
            </v-list-item>
            <v-divider />
            <v-list-item
              class="red--text"
              @click="logout()"
            >
              <v-list-item-title>Logout</v-list-item-title>
              <v-list-item-icon>
                <v-icon color="red">
                  mdi-export
                </v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col cols="auto">
        <v-btn
          text
          @click="logout()"
        >
          <v-icon>mdi-export</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      class="logged-in-user--info"
      no-gutters
    >
      <v-col>
        {{ loginAdmin.email }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ChangePassword from "@/components/user/password/changePassword";
export default {
  name: "LoggedInUser",
  components: {
    ChangePassword
  },
  data() {
    return {
      loginAdmin: {}
    };
  },
  created() {
    var admin = localStorage.getItem("login_user");
    if (admin) {
      this.loginAdmin = JSON.parse(admin);
    }
  },
  methods: {
    logout() {
			this.$root.$confirm
				.open("Confirm", "Are you sure want to logout?", {})
				.then((confirm) => {
					if (confirm) {
						localStorage.removeItem("login_user");
						this.$router.push({
							name: "login"
						});
					}
				});
		}
  }
};
</script>

<style lang="scss">
.logged-in-user {
  color: white;
  &--name {
    font-size: 20px;
    font-weight: 900;
    position: relative;
    z-index: 50;
    flex-shrink: 0;
  }

  &--info {
    font-size: 13px;
    text-transform: lowercase;
  }
}
</style>